var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-wrapper"},[_c('intro-header'),_c('div',[_c('div',{staticClass:"intromain",style:(_vm.containerStyles)},[_c(_vm.currentComponent,{tag:"component",attrs:{"sushi":_vm.isSushi}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }